import { render, staticRenderFns } from "./legal_check.vue?vue&type=template&id=3e482b6c&scoped=true"
import script from "./legal_check.vue?vue&type=script&lang=js"
export * from "./legal_check.vue?vue&type=script&lang=js"
import style0 from "./legal_check.vue?vue&type=style&index=0&id=3e482b6c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e482b6c",
  null
  
)

export default component.exports